module.exports = __webpack_public_path__ + "static/media/28_B.7275bd76.png";